import { SvgIcon } from '../SvgIcon';
import * as React from 'react';

interface IProps {
	className?: string;
	fillColor?: string;
}

export const MainContactIcon: React.FC<IProps> = props => {
	const { className, fillColor } = props;
	return (
		<SvgIcon className={`merge-icon ${className || ''}`} height={16} width={18}>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M8.727 13.033v-.67H7.273v.67a5.093 5.093 0 01-4.306-4.306h.67V7.273h-.67a5.094 5.094 0 014.306-4.306v.67h1.454v-.67a5.094 5.094 0 014.306 4.306h-.67v1.454h.67a5.093 5.093 0 01-4.306 4.306zM16 7.273h-1.498a6.554 6.554 0 00-5.775-5.775V0H7.273v1.498a6.554 6.554 0 00-5.776 5.775H0v1.454h1.497a6.555 6.555 0 005.776 5.775V16h1.454v-1.498a6.555 6.555 0 005.775-5.775H16V7.273z'
				fill={fillColor || '#C75DA6'}
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M5.781 10.91c0-1.34.843-2.183 2.182-2.183s2.182.843 2.182 2.182H5.78zm3.637-4.365a1.455 1.455 0 11-2.91 0 1.455 1.455 0 012.91 0z'
				fill={fillColor || '#C75DA6'}
			/>
		</SvgIcon>
	);
};
